'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prd = {
  merchantConfigUrl: 'https://merchant-config.commerce.cimpress.io',
  fulfillerIdentityUrl: 'https://fulfilleridentity.trdlnk.cimpress.io',
  customizrUrl: 'https://customizr.at.cimpress.io'
};
var int = {
  merchantConfigUrl: 'https://int-merchant-config.commerce.cimpress.io',
  fulfillerIdentityUrl: 'https://fulfilleridentity.trdlnk.cimpress.io',
  customizrUrl: 'https://customizr.at.cimpress.io'
};
var local = {
  merchantConfigUrl: 'http://localhost:9101',
  fulfillerIdentityUrl: 'http://localhost:9101',
  customizrUrl: 'http://localhost:9101'
};
exports.default = {
  prd: prd,
  int: int,
  local: local
};